import { createElement as h, memo, createRef } from 'react'
import { createPortal } from 'react-dom'
import { BpmLoading, loadingDom } from './utils/loading'
import { insertGlobalTool } from './utils'
import './static/css'

const loadingRef = createRef()
insertGlobalTool({ loadingRef })

export const InjectLiveCloud = memo(() => {
  return createPortal(h(BpmLoading, { ref: loadingRef }), loadingDom)
})